import { render, staticRenderFns } from "./goodsSort.vue?vue&type=template&id=57271063&scoped=true&"
import script from "./goodsSort.vue?vue&type=script&lang=js&"
export * from "./goodsSort.vue?vue&type=script&lang=js&"
import style0 from "./goodsSort.vue?vue&type=style&index=0&id=57271063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57271063",
  null
  
)

export default component.exports